export const loginSuccess = (state, params) => {
	const { payload: user } = params;
  state.isLogged = true;
  state.user = user;
  console.log('reducer login', state);
  return state;
};
export const loginFail = (state) => {
  state.isLogged = false;
  return state;
};
export const logout = (state) => {
  state.isLogged = null;
  return state;
};

export default {};